module.exports = __webpack_public_path__ + "assets/san-francisco-recruiting-agency-1.92c022a7.png";